import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RectangleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"rectangle"}/>
}
